import PropTypes from "prop-types";
import React, { Component } from "react";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import {
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography
} from "@material-ui/core";
import styled, { css } from "styled-components";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ReactDataGrid from "@inovua/reactdatagrid-enterprise";
import moment from "moment";
import withTheme from "@material-ui/core/styles/withTheme";
import GridFrequencyService from "../../services/GridFrequencyService";
import ClassService from "../../services/ClassService";
import Group from "../../waybee-ui/Group";
import HeaderDetails from "../ClassGradesV2/components/HeaderDetails";
import HoverPopover from "../../components/HoverPopover";
import translate from "../../components/DataGrid/translate.json";
import BackButton from "../../components/BackButton";
import TeacherService from "../../services/TeacherService";

const LoadContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

const CellText = styled.p`
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: ${props => (props.cellHeight ? 2.5 : "normal")};
  ${({ editable }) =>
    !!editable &&
    css`
      margin: 0;
      border: 1px solid rgba(0, 0, 0, 0.25);
      padding: 5px;
      border-radius: 5px;
      min-height: 30px;
    `}
`;

const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const RollNum = styled.span`
  color: ${({ theme }) => theme.color.primary.main};
  margin-right: 12px;
`;

const Header = styled(Grid)`
  background-color: white;
  border-right: 1px solid #e4e3e2;
  border-top: 1px solid #e4e3e2;
  border-left: 1px solid #e4e3e2;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
`;

class GridFrequency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingFilters: false,
      courses: [],
      filter: {},
      selectedDate: {
        dateFrom: moment()
          .startOf("week")
          .format("YYYY-MM-DDTHH:mm:ss"),
        dateTo: moment().format("YYYY-MM-DDTHH:mm:ss")
      },
      dataSource: [],
      columns: [],
      groups: [],
      loadingTable: false,
      gridRef: null,
      isClassDoubleActive: true,
      doubleClasses: {}
    };
  }

  componentDidMount() {
    this.getCourses().then(() => this.getGridFrequency());
  }

  getCourses = async () => {
    const { match } = this.props;

    this.setState({ loadingFilters: true });

    const classId = match.params.id;
    try {
      const disciplines = await ClassService.getDisciplines(classId);
      this.setState({ courses: disciplines });
      if (disciplines && disciplines.length) {
        this.setFilter("course", disciplines[0]);
      }
      this.setState({ loadingFilters: false });
    } catch (e) {
      console.error(e);
      alert.show("Ocorreu um erro ao buscar as disciplinas", { title: "Erro" });
    }
  };

  getGridFrequency = async () => {
    const { filter, selectedDate, isClassDoubleActive } = this.state;
    const { dateFrom, dateTo } = selectedDate;
    const { theme } = this.props;
    this.setState({ loadingTable: true });

    const frequencyGrid = await GridFrequencyService.getFrequency(
      filter.course.idTurmaDisc,
      dateFrom,
      dateTo
    );

    const groups = frequencyGrid.groups.map(group => ({
      ...group,
      header: <HeaderDetails title={group.header} />
    }));

    const columns = frequencyGrid.headers.map(column => {
      if (column.double === "true") {
        this.handleDoubleClass(column);
      }

      return {
        id: column.id,
        name: column.id,
        header: column.header,
        group: column.group,
        defaultWidth: 185,
        showColumnMenuTool: false,
        rendersInlineEditor: true,
        headerProps: {
          style:
            column.double === "true" && isClassDoubleActive
              ? {
                  borderBottom: `2px solid ${theme.palette.primary.main}`
                }
              : {
                  borderBottom: "none"
                }
        },
        render: ({ data }, { cellProps }) => {
          const columnData = Array.isArray(data)
            ? Object.fromEntries(data.map(item => [item.columnId, { ...item }]))
            : {};

          if (columnData[column.id] && columnData[column.id].totalAbsences) {
            return (
              <CellText style={{ display: "flex", justifyContent: "center" }}>
                {columnData[column.id].totalAbsences}
              </CellText>
            );
          }

          const hasAttended =
            columnData[column.id] ||
            (columnData[column.id] &&
              columnData[column.id].absence !== "false");

          const switchValue = cellProps.editProps.inEdit
            ? cellProps.editProps.value === "true"
            : hasAttended;

          const controlledSwitchValue =
            switchValue !== undefined ? switchValue : false;

          return (
            <CellContainer data-id={column.id + data[0].studentId}>
              <Switch
                id={column.id}
                checked={controlledSwitchValue}
                onClick={e => this.handleOnClickSwitch(e, cellProps, column)}
              />
            </CellContainer>
          );
        },
        renderHeader: ({ value }) => {
          const splitString = value.split(";");
          const getTimeFrom = splitString[splitString.length - 3];
          const getTimeTo = splitString[splitString.length - 2];
          const getFullDate = splitString[splitString.length - 1];

          const dayAndMonth = moment(getFullDate).format("DD/MM");
          const weekDay = moment(getFullDate)
            .locale("pt-br")
            .format("dddd");

          return (
            <CellContainer>
              {column.date ? (
                [
                  { title: dayAndMonth },
                  { title: weekDay },
                  { title: `${getTimeFrom} - ${getTimeTo}` }
                ].map(item => (
                  <HeaderDetails
                    key={value.id + item.title}
                    title={item.title}
                    rowHeight={165}
                    hasDetails
                    column={column}
                    weight="400"
                  />
                ))
              ) : (
                <HeaderDetails
                  title={column.title}
                  rowHeight={165}
                  color={column.color}
                  hasDetails
                  column={column}
                />
              )}
            </CellContainer>
          );
        }
      };
    });

    const tableEl = document.querySelector(".studentIdFrequency");
    columns.unshift({
      name: "studentId",
      header: "R.A.",
      editable: false,
      locked: true,
      group: "data",
      showColumnMenuTool: false,
      defaultWidth: tableEl ? tableEl.offsetWidth * 0.15 : 150,
      render: ({ data }) => <CellText>{data[0].studentId}</CellText>,
      renderHeader: ({ value }) => <HeaderDetails title={value} />
    });
    columns.unshift({
      name: "name",
      header: "Aluno",
      editable: false,
      locked: true,
      sortable: true,
      group: "data",
      showColumnMenuLockOptions: false,
      showColumnMenuGroupOptions: false,
      showColumnMenuFilterOptions: false,
      defaultWidth: tableEl ? tableEl.offsetWidth * 0.35 : 350,
      render: ({ data }, { column }) => {
        return (
          <HoverPopover key={data.id} id={data.id} value={data[0].name}>
            <CellText>
              <RollNum>{column.rollCallNumber}</RollNum>
              {data[0].name}
            </CellText>
          </HoverPopover>
        );
      },
      renderHeader: ({ value }) => <HeaderDetails title={value} />
    });

    this.setState({
      columns,
      dataSource: frequencyGrid.lines,
      groups,
      loadingTable: false
    });
  };

  setFilter(field, value) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
  }

  handleOnClickSwitch = (e, cellProps, column) => {
    const { doubleClasses, isClassDoubleActive } = this.state;
    const hasDoubleClass = doubleClasses[column.date];
    const targetDoubleAttribute = e.target.getAttribute("doubleRelatedCell");

    if (isClassDoubleActive) {
      if (hasDoubleClass && targetDoubleAttribute !== "true") {
        const doubleClass = hasDoubleClass.find(
          classColumn => classColumn.id !== column.id
        );
        const doubleCellRelated = doubleClass.id + cellProps.data[0].studentId;
        const cellDouble = document.querySelector(
          `[data-id='${doubleCellRelated}'] input`
        );

        if (cellDouble.checked !== e.target.checked) {
          cellDouble.setAttribute("doubleRelatedCell", true);
          requestAnimationFrame(() => {
            cellDouble.click();
          });
        }
      } else if (hasDoubleClass) {
        e.target.setAttribute("doubleRelatedCell", false);
      }
    }

    e.target.value = e.target.checked;
    cellProps.editProps.onChange(e);
  };

  handleDoubleClass = async column => {
    const { doubleClasses } = this.state;
    const doubleClassesState = doubleClasses;
    const lastKey = column.date;
    const currentClassDouble = doubleClassesState[lastKey] || [];

    doubleClassesState[lastKey] =
      currentClassDouble.length < 2
        ? [...currentClassDouble, column]
        : (doubleClassesState[column.date] = [column]);

    await this.setState({ doubleClasses: doubleClassesState });
  };

  changeCourse = async e => {
    const { match } = this.props;

    const classId = match.params.id;
    this.setState({ loadingFilters: true });
    this.setFilter("course", e.target.value);
    await ClassService.getDisciplines(classId);
    await this.getGridFrequency();
    this.setState({ loadingFilters: false });
  };

  handleDateFromChange = async date => {
    if (!date) return;

    const formattedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss");

    await this.setState(prevState => ({
      selectedDate: {
        ...prevState.selectedDate,
        dateFrom: formattedDate
      }
    }));

    this.getGridFrequency();
  };

  handleDateToChange = async date => {
    if (!date) return;

    const formattedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss");

    await this.setState(prevState => ({
      selectedDate: {
        ...prevState.selectedDate,
        dateTo: formattedDate
      }
    }));

    this.getGridFrequency();
  };

  scrollTo = index => {
    const { gridRef, columns } = this.state;
    const columnId = parseInt(Object.keys(index)[0].split(",")[1], 10);
    const scrollTo = columnId + 4;

    if (scrollTo <= columns.length) {
      gridRef.current.scrollToColumn(scrollTo, { duration: 100 });
    }
  };

  formatSelectedDate = schedule => {
    const [hour, minute] = schedule.startTime.split(":");
    return moment(schedule.date)
      .set({ hour, minute })
      .format("YYYY-MM-DD HH:mm:SS");
  };

  onEditComplete = async ({ value, columnId, rowIndex, data }) => {
    const { dataSource } = this.state;

    const columnData = columnId.split(";");
    const studentId = data[0] && data[0].studentId;
    const schedule = {
      date: columnData[columnData.length - 1],
      startTime: columnData[columnData.length - 3]
    };
    const editedDataSource = [...dataSource];
    const currentColumn = editedDataSource[rowIndex] || [];

    const columnIndex = currentColumn.findIndex(
      item => item.columnId === columnId
    );

    const studentAttendanceData = {
      columnId,
      absence: value === "true" ? "false" : "true",
      idHorarioTurma: columnData[2],
      idTurmaDisc: columnData[1],
      studentId
    };

    if (columnIndex !== -1) {
      currentColumn.splice(columnIndex, 1);
    } else {
      currentColumn.push(studentAttendanceData);
    }

    const studentAttendance = {
      studentId,
      idTurmaDisc: studentAttendanceData.idTurmaDisc,
      idSchedule: studentAttendanceData.idHorarioTurma,
      value: studentAttendanceData.absence === "true" ? "P" : "A"
    };

    const date = this.formatSelectedDate(schedule);

    const absenceData = {
      date,
      absences: [studentAttendance],
      occurrences: [],
      removed: []
    };

    try {
      await TeacherService.saveOccurrence(absenceData);
    } catch (e) {
      const { alert } = this.props;
      alert.show(`Erro ao atribuir frequência`, { title: "Erro" });
    }

    this.setState({ dataSource: editedDataSource });
  };

  handleAttachedClasses = async () => {
    await this.setState(prevState => ({
      isClassDoubleActive: !prevState.isClassDoubleActive
    }));
    await this.getGridFrequency();
  };

  render() {
    const {
      courses,
      filter,
      loadingFilters,
      selectedDate,
      columns,
      groups,
      loadingTable,
      dataSource,
      isClassDoubleActive
    } = this.state;

    const { history } = this.props;

    const menu = menuProps => {
      menuProps.items.splice(-2, 2);
    };

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={2}>
          <BackButton onClick={history.goBack} />
          <Grid item xs={12}>
            <Group fullWidth>
              {loadingFilters ? (
                <LoadContainer>
                  <CircularProgress />
                </LoadContainer>
              ) : (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel id="filter-course-label">
                        Disciplina
                      </InputLabel>
                      <Select
                        fullWidth
                        labelId="filter-course-label"
                        value={filter.course}
                        onChange={this.changeCourse}
                      >
                        {courses.map(course => (
                          <MenuItem value={course}>{course.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2} />
                  <Grid item xs={2}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Data a partir"
                      value={selectedDate.dateFrom}
                      onChange={this.handleDateFromChange}
                      maxDate={new Date()}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Data até"
                      value={selectedDate.dateTo}
                      onChange={this.handleDateToChange}
                      maxDate={new Date()}
                    />
                  </Grid>
                </Grid>
              )}
            </Group>
          </Grid>
          {!loadingFilters && (
            <Grid item xs={12}>
              {loadingTable ? (
                <LoadContainer>
                  <CircularProgress />
                </LoadContainer>
              ) : (
                <>
                  <Header
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Switch checked />
                      <Typography
                        style={{ margin: 0, padding: "0 12px 0 12px" }}
                        variant="h6"
                      >
                        Ausente
                      </Typography>
                      <Switch checked={false} />
                      <Typography
                        style={{ margin: 0, padding: "0 12px 0 12px" }}
                        variant="h6"
                      >
                        Presente
                      </Typography>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Switch
                        checked={isClassDoubleActive}
                        onClick={this.handleAttachedClasses}
                        color="primary"
                      />
                      <Typography
                        style={{ margin: 0, padding: "0 12px 0 12px" }}
                        variant="h6"
                      >
                        Marcar aulas geminadas
                      </Typography>
                    </div>
                  </Header>
                  <ReactDataGrid
                    columns={columns}
                    groups={groups}
                    dataSource={dataSource}
                    rowHeight={50}
                    style={{ minHeight: 550 }}
                    licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
                    idProperty="studentIdFrequency"
                    i18n={translate.i18n}
                    reorderColumns={false}
                    onColumnLockedChange={e => e}
                    onReady={e => this.setState({ gridRef: e })}
                    onEditComplete={this.onEditComplete}
                    onEditValueChange={this.onEditComplete}
                    editable
                    renderColumnContextMenu={menuProps => menu(menuProps)}
                    resizable
                    sortable={false}
                    showColumnMenuToolOnHover={false}
                    enableColumnAutosize
                    defaultLocked
                  />
                </>
              )}
            </Grid>
          )}
        </Grid>
      </MuiPickersUtilsProvider>
    );
  }
}

GridFrequency.propTypes = {
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.any
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.any
    })
  }).isRequired,
  theme: PropTypes.objectOf().isRequired
};

export default withAlert()(withRouter(withTheme(GridFrequency)));
